import CryptoJS from "crypto-js";

const getKey = () => {
  return window.location.host === "www.pitagepe.com" ||
    window.location.host === "pitagepe.com"
    ? "B95DB23C534B1AE802671170DE6F6974"
    : "6F97F4964715FAF50D5439DBF3FCBAC4";
};

//解密方法 AES/ECB/PKCS5Padding
export const aesDecrypt = (word: string) => {
  let key = CryptoJS.enc.Hex.parse(getKey());

  let encryptedHexStr = CryptoJS.enc.Base64.parse(word);
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let decrypt = CryptoJS.AES.decrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
};

//加密方法 AES/ECB/PKCS5Padding
export const aesEncrypt = (word: string) => {
  let key = CryptoJS.enc.Hex.parse(getKey());

  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
};

const aesUtils = { aesDecrypt, aesEncrypt };
export default aesUtils;
